import { StepsNavigation, type NavItem } from "../common/StepsNavigation";
import { StepsFooter } from "../common/StepsFooter";
import Header from "../Header";
import RightAside from "../RightAside";
import UserService from "../../services/UserService";
import { productRoleName, rolesAtOrAbove } from "../../utils/common/productRoles";
import { mapUrlToProductId } from "../../utils/common/mapUrlToProduct";
import { Link } from "react-router-dom";
import React from "react";

const UNDERWRITING_ENGINE_PRODUCT_ID = mapUrlToProductId("underwriting-engine") as number;

interface AppLayoutProps {
  children: React.ReactNode;
  currentStep: "Loans" | "Application" | "Score" | "Review" | "Underwrite";
  onStepChange?: (step: "Loans" | "Application" | "Score" | "Review" | "Underwrite") => void;
}

const stepsOrder: ("Loans" | "Application" | "Score" | "Review" | "Underwrite")[] = ["Loans", "Application", "Score", "Review", "Underwrite"];

// Convert steps to NavItem format for common components
const navItems: NavItem[] = stepsOrder.map((step, index) => ({
  path: `/underwriting-engine-v2/${step.toLowerCase()}`,
  label: step,
}));

const basePath = "/underwriting-engine-v2/loans";

export function AppLayout({ children, currentStep, onStepChange }: AppLayoutProps) {
  const currentIndex = stepsOrder.indexOf(currentStep);
  const token = UserService.getToken();
  const canAccessController: boolean = UserService.hasRole(
    rolesAtOrAbove(UNDERWRITING_ENGINE_PRODUCT_ID, "contributor")
  );
  const isProductAdmin: boolean = UserService.hasRole([
    productRoleName(UNDERWRITING_ENGINE_PRODUCT_ID, "admin"),
  ]);

  // Handle step change from common components
  const handleStepChange = (index: number) => {
    if (onStepChange && index < stepsOrder.length) {
      onStepChange(stepsOrder[index]);
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
        <Header
          token={token}
          isMarketplacePage={false}
          notificationsCount={0}
          refreshNotifications={() => {}}
          setIndustry={() => {}}
          setCompany={() => {}}
          leftNode={null}
          productLabel="Underwriting Engine"
          fixed={true}
        />
          <StepsNavigation
            navItems={navItems}
            basePath={basePath}
            currentStepIndex={currentIndex}
            nextBlocked={true}
            onStepChange={handleStepChange}
          />

      <main className="flex-1 p-6 animate-fade-in pt-[200px] pb-[80px]">
        {(canAccessController || isProductAdmin) && (
          <div className="flex justify-end gap-4 mb-3">
            {canAccessController && (
              <Link
                to="/underwriting-engine/controller"
                className="text-xs font-medium text-amber hover:underline"
              >
                Guardrails Controller →
              </Link>
            )}
            {isProductAdmin && (
              <Link
                to="/underwriting-engine/manage-access"
                className="text-xs font-medium text-amber hover:underline"
              >
                Manage Access →
              </Link>
            )}
          </div>
        )}
        {children}
      </main>

      <StepsFooter
        navItems={navItems}
        basePath={basePath}
        currentStepIndex={currentIndex}
        isFirstStepHidden={true}
        onStepChange={handleStepChange}
      />
      <RightAside showChildrenWhenNoPanel={false}>{null}</RightAside>
              </div>

  );
}

